(() => {
  const started = new Set();
  function allowed(purpose) {
    const privacy = window.AttributionPrivacy;
    if (!privacy) return false;
    if (purpose === 'analytics') return privacy.analyticsAllowed();
    if (purpose === 'ads') return privacy.adsAllowed();
    return privacy.analyticsAllowed() && privacy.adsAllowed();
  }
  function refresh() {
    if ([...started].some(purpose => !allowed(purpose))) {
      window.location.reload();
      return;
    }
    document.querySelectorAll('script[type="text/plain"][data-privacy-purpose]').forEach(source => {
      const purpose = source.dataset.privacyPurpose;
      if (!allowed(purpose)) return;
      const script = document.createElement('script');
      for (const attr of source.attributes) {
        if (attr.name !== 'type' && attr.name !== 'data-privacy-purpose') script.setAttribute(attr.name, attr.value);
      }
      script.async = false;
      script.textContent = source.textContent;
      started.add(purpose);
      source.replaceWith(script);
    });
  }
  document.addEventListener('attribution:privacy-ready', refresh);
  document.addEventListener('visitorConsentCollected', () => setTimeout(refresh, 0));
  refresh();
})();
